{
  "version": 1,
  "asset_id": "827085f1-034b-4cd0-9986-504cc85d0dfa",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/827085f1-034b-4cd0-9986-504cc85d0dfa/Smartlane_Produktinformation.pdf",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/827085f1-034b-4cd0-9986-504cc85d0dfa/Smartlane_Produktinformation.pdf",
  "original_filename": "Smartlane_Produktinformation.pdf",
  "size": 279023,
  "content_type": "application/pdf",
  "created_at": "2026-07-10T10:56:55Z"
}
